// custom scripts
// mcs 2023


var lastScrollTop = 0;

// WINDOW SCROLLED
$(window).scroll(function() {  

  
  var st = $(this).scrollTop();
  if (st > lastScrollTop){
      // Downscroll code
      $("body").addClass("being-scrolled-down");
  } else {
      // Upscroll code
      $("body").addClass("being-scrolled-up");
  }
  lastScrollTop = st;

  
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 500) {
      $("body").addClass("scrolled2");
  } else {
      $("body").removeClass("scrolled2");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  
});



$(document).ready(function() {


  //console.log( "ready!" );
  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');
  }, 3000);





  $('.mcs-mobile-nav-click').click(function() {
    $('.mcs-mobile-nav').toggleClass('active');
  });




  $('.product-addons1 .product-addon').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
  });
  $('.product-addons2 .product-addon').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
  });


  
  $(".hamburger").click(function(){
    $(this).toggleClass("is-active");
  });


 $('.tabs-wrap  .tab').on('click', function(evt) {
    evt.preventDefault();
    $(this).siblings().removeClass('active');
    $(this).toggleClass('active');
    var sel = this.getAttribute('data-toggle-target');
    $('.tab-content').removeClass('active').filter(sel).addClass('active');
  });


  $('.tab-buttons span').first().addClass('active');
  $('.tab-content>div').hide();
  $('.tab-content>div').first().slideDown();
    $('.tab-buttons span').click(function(){
      $('.tab-buttons span').removeClass('active');
      var thisclass=$(this).attr('class');
      $(this).addClass('active');
      $('.tab-content>div').each(function(){
        if($(this).hasClass(thisclass)){
          $(this).fadeIn(800);
        }
        else{
          $(this).hide();
        }
      });
    });




    // $('.m-add-to-cart').on('click', function(e) {
    //     e.preventDefault();
        
    //     const productId = $(this).data('product-id'); // Get ID from data attribute
    //     // const quantity = parseInt($('.quantity').val()) || 1;

        
    //     $.ajax({
    //         type: 'POST',
    //         url: '/cart/add.js',
    //         dataType: 'json',
    //         data: {
    //             quantity: 1,
    //             id: productId
    //         },
    //         success: function(itemAdded) {
    //             // Update cart UI
    //             fetch(window.Shopify.routes.root + 'cart.js')
    //                 .then(response => response.json())
    //                 .then(cart => updateCartUI(cart));
    //         },
    //         error: function(xhr, status) {
    //             alert(productId);
    //             alert('Sorry, there was an error adding the item to cart.');
    //         }
    //     });
    // });



  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 120
          }, 1000);
          return false;
        }
      }
    });
  });


  $('.mcs-product-slider').flickity({
    wrapAround: true,
    pageDots: false,
    cellAlign: 'left',
    pauseAutoPlayOnHover: false,
    autoPlay: 4000,
    prevNextButtons: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });

  $('.mcs-testimonial').flickity({
    wrapAround: true,
    pageDots: false,
    cellAlign: 'left',
    pauseAutoPlayOnHover: false,
    autoPlay: 4000,
    prevNextButtons: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });

  $('.mcs-gallery').flickity({
    wrapAround: true,
    pageDots: false,
    cellAlign: 'left',
    pauseAutoPlayOnHover: false,
    autoPlay: 4000,
    prevNextButtons: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });

    

}); // clode doc ready



$(document).ready(function() {
  $(document).on('mouseenter', '.color-swatch a', function() {
    var image = $(this).attr('data-image');
    var parent = $(this).closest('.card-wrapper');
    console.log(image);
    $(parent).find('.card__media img').attr('src',image).attr('srcset',image)
  });
});





$(window).on('load', function() {

  

});




